<template>
	<div class="home">
		<BackgroundVideo src="pd/100000/coverloop" class="home__video" @loadeddata="onVideoLoaded" />

		<div class="home__body" v-show="videoHasLoaded">
			<div class="home__headline">
				<h1>Together We're Smarter</h1>
			</div>
			<div class="home__pathways">
				<btn class="home__cta">
					<router-link to="/webinars">Free Webinars</router-link>
				</btn>
				<btn class="home__cta">
					<router-link :to="{name: 'theDailySync'}">The Daily Sync</router-link>
				</btn>
				<!-- <btn class="home__cta">
					<router-link to="/remote-resources">Remote Resources</router-link>
				</btn> -->
				<btn class="home__cta">
					<button @click.prevent="$store.commit('app/setActiveVideoModal', 'pd/100000/together_high')">Watch the Promo</button>
				</btn>
			</div>
		</div>

		<anchor-link el="a" to="home-tour" class="next-anchor" title="Company Tour"><sprite name="arrow" class="next-anchor__arrow" /></anchor-link>
	</div>
</template>

<script>

	import { AnchorLink } from "@/components/AnchorNav"
	import BackgroundVideo from '@/components/VideoServerBackgroundVideo'

	export default {
		name: 'homeBgVideo',
		components: { AnchorLink, BackgroundVideo },
		data () {
			return {
				videoHasLoaded: false
			}
		},
		methods: {
			onVideoLoaded () {
				this.videoHasLoaded = true
			}
		},
		watch: {
			'$root.videoOn' (videoOn) {
				if(videoOn) {
					this.$refs.video.pause()
				} else {
					this.$refs.video.play()
				}
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import "media.scss";

	.home {
		display:flex; flex:1; position:relative; background:#000000;
		@include media(small, large) {
			padding:10rem 2.4rem;
		}
		&__video {
			max-width:none; max-height:100%; min-width:100%; min-height:100%; object-fit:cover; position:absolute; top:0; left:0;
			@include media(small, large) {
				max-width:100%;
			}
		}

		&__body {
			display:flex; justify-content:center; flex-direction:column; flex:1; text-transform:uppercase; color:#FFF; position:relative;
			@include media(large) {
				margin:0 auto; align-items:center;
			}
		}

		&__headline {
			position:relative; font-family: "Oswald";
			h1 {
				margin:0; font-size:16vw; line-height:1; font-weight:400; text-align:center;
				@include media(large) {
					font-size:6vw;
				}
			}
		}

		&__pathways {
			@include media(large) {
				display:flex;
			}
		}

		&__cta {
			display:block; margin:2.5rem auto 0 0; text-transform:none;
			button {
				display:block; width:100%; font-size:2rem; cursor: pointer;
			}
			a {font-size:2rem;}
			@include media(large) {
				& + & {
					margin-left:2.5rem;
				}
			}
		}
	}

	.next-anchor {
		position: absolute; bottom: 2.6rem; left: 50%; transform:translateX(-50%); cursor: pointer; padding: 0 1rem;
		&__arrow {
			fill:#fff; width:2.6rem; height:2.6rem; vertical-align:middle;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/LiveToLearn/index.vue